/**
 * Minimal WebSocket surface both this package's client and server registry
 * depend on. Deliberately NOT the DOM `WebSocket` type (this package's
 * tsconfig has no `dom` lib — it must stay usable from a Node worker/test as
 * well as a browser bundle). Both the native browser `WebSocket` and the
 * `ws` npm package's `WebSocket` satisfy this shape (`onopen`/`onmessage`/
 * `onclose`/`onerror` properties + `readyState`/`send`/`close`), so callers
 * pass either straight through a `WebSocketFactory` without an adapter.
 */
/** Mirrors the standard readyState values without importing the DOM lib. */
export const READY_STATE = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
};
